export const CHANNEL_NAME = "AnacondaToolboxBroadcast";
